import supabase from 'modules/core/supabase/supabase';

/**
 * Активное табло из строки журнала матча — только для первичной установки.
 *
 * Возвращает `undefined` лишь тогда, когда строка **прочитана** и табло в ней действительно
 * выключено. Сорванный запрос бросает исключение: `getRow` отвечает `null` и на сетевую
 * ошибку тоже (`match-chronology.ts:84-95`), а раньше вызывающий код гасил табло на любой
 * такой `null` — одна неудачная попытка посреди эфира стирала картинку (IMGM-1435).
 */
export async function getCurrentBoard(matchId: number): Promise<number | undefined> {
  const row = await supabase.matchChronology.getRow(matchId);
  // eslint-disable-next-line lingui/no-unlocalized-strings -- текст Error для журнала оверлея, не интерфейс
  if (!row) throw new Error(`Не удалось прочитать строку журнала матча ${matchId}`);
  return row.templateId ?? undefined;
}
